var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11 3.383a7.7 7.7 0 1 0 4.928 13.618l3.578 3.577a.7.7 0 0 0 .99-.99l-3.578-3.577a7.7 7.7 0 0 0-5.917-12.627m-6.3 7.7a6.3 6.3 0 1 1 12.6 0 6.3 6.3 0 0 1-12.6 0",
  clipRule: "evenodd"
})));
export default SvgSearch;